

import map from './../search/map';


// selectors

const containerSelector = '.js-locations';
const mapElementSelector = '.js-locations__map';
const locationSelector = '.js-locations__location';
const listSelector = '.js-locations__list';


// init

	export function init() {
		$(containerSelector).each(function() {

			const $container = $(this);
			const $mapElement = $container.find(mapElementSelector);
			const $locations = $container.find(locationSelector);
			const $listElement = $container.find(listSelector);
			const locationMap = new LocationsMap($container, $mapElement, $listElement);
			const locationData = [];

			$locations.each(function() {
				const data = $(this).data('location');
				data.$elem = $(this);
				locationData.push(data);
			});

			$(this).lazyLoadOnScroll({
				handler : function() {
					locationMap.render(locationData);
				}
			});
		});
	}

// class export 

	function LocationsMap($container = null, $mapElement = null, $listElement = null) {

		this.googleMap = false; 
		this.markerBounds = false;
		this.gmapObjects = [];

		this.$container = $container;
		this.$mapElement = $mapElement;
		this.$listElement = $listElement;
	}


	LocationsMap.prototype.removeAllMarkers = function() {

		for (var i = 0; i < this.gmapObjects.length; i++) {
			this.gmapObjects[i].setMap(null);
		}
        // empty markers object and array
        this.gmapObjects = [];
	}


	LocationsMap.prototype.addMarkerWithLabel = function(location, map) {

		var itemLatLng = new google.maps.LatLng(
			location.latitude, 
			location.longitude
		);

		var markerIcon = {
			url: siteSettings.templateUri + '/assets/img/map-pin.svg',
			scaledSize: new google.maps.Size(26, 26),
			origin: new google.maps.Point(0,0),
			anchor: new google.maps.Point(13,13)
		};


		var marker = new MarkerWithLabel({
			map: map,
			position: itemLatLng,
			// animation: google.maps.Animation.DROP,
			icon: markerIcon,
			labelContent: '',
			labelAnchor: new google.maps.Point(0, 0),
			labelClass: "gmaps-pin-pulsate", // your desired CSS class
			labelInBackground: false
		});

		// add marker to array
		this.gmapObjects.push(marker);

		const hideOthers = () => {
			for (var i = 0; i < this.gmapObjects.length; i++) {
				const m = this.gmapObjects[i];
				m.setOptions({
					'opacity': 0.4,
					'labelClass' : false
				});
			}
			marker.setOptions({
				'opacity': 1,
				'labelClass' : 'gmaps-pin-pulsate'
			});
			this.$listElement.addClass('hover');
			location.$elem.addClass('hover');
		};

		const showAll = () => {
			for (var i = 0; i < this.gmapObjects.length; i++) {
				const m = this.gmapObjects[i];
				m.setOptions({
					'opacity': 1,
					'labelClass' : 'gmaps-pin-pulsate'
				});
			}
			this.$listElement.removeClass('hover');
			location.$elem.removeClass('hover');
		}

		location.$elem.on('mouseover', () => {
			hideOthers();
			$(this).addClass('hover');
		});
	
		location.$elem.on('mouseout', () => {
			showAll();
		});

		// add hover 
		google.maps.event.addListener(marker, 'mouseover', () => {
			hideOthers();
		});

		google.maps.event.addListener(marker, 'mouseout', () => {
			showAll();
		});		

		// add click event
		google.maps.event.addListener(marker, 'click', () => {
			location.$elem.find('a').get(0).click();
	    });

		this.markerBounds.extend(itemLatLng);
	}


	LocationsMap.prototype.render = function(locations) {

		if (!locations) return false;

		const setupMap = () => {

			if (this.googleMap) this.removeAllMarkers();

			// setup map only once
			if (!this.googleMap) {

				const mapOptions = map.defaultMapOptions();
				mapOptions.center = new google.maps.LatLng(52.2991848, 0.6177434); // default centre
				
				// create map
				this.googleMap = new google.maps.Map(this.$mapElement[0], mapOptions);

				google.maps.event.addListenerOnce(this.googleMap, 'bounds_changed', function() { 
					this.setZoom(Math.min(12, this.getZoom())); 
				});

				// set centre 
				this.markerBounds = new google.maps.LatLngBounds();
			}

			for (let location in locations) {
				this.addMarkerWithLabel(locations[location], this.googleMap);
			}

			this.googleMap.fitBounds(this.markerBounds);
		}


		map.load(setupMap);		
	}



export default {
	init
}